exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "input.NumberInput {\n  max-width: 200px;\n}\n", ""]);

